import { useQuery } from '@tanstack/react-query';
import { useAPI } from '@pella/cosmos-react';
import { QUERY_KEYS } from '../../utils/enums';

/**
 * Hook to fetch sub-inventories for a given MRO organization.
 * @param {string|number} orgId - The organization ID to fetch sub-inventories for.
 * @returns {object} Sub-inventories query result with data, loading, success, and error states.
 */
export const useSubInventories = (orgId) => {
  const { api, apiReady } = useAPI();
  const numOrgId = Number(orgId);
  const { data, isLoading, isSuccess, isError, error } = useQuery({
    queryKey: [QUERY_KEYS.INV_MGMT_SUB_INVENTORIES, numOrgId],
    queryFn: () =>
      api.orgManagement.getOrgSubInvLocs({
        orgid: numOrgId,
      }),
    enabled: apiReady && Boolean(orgId) && Number.isFinite(numOrgId),
    staleTime: Number.POSITIVE_INFINITY,
  });
  return {
    subInventories: data,
    subInventoriesIsLoading: isLoading,
    subInventoriesIsSuccess: isSuccess,
    subInventoriesIsError: isError,
    subInventoriesError: error,
  };
};
